<template>
  <div class="send">
    <div class="send__title">
      <!-- Add a transition in/out here cf/ Vue.js -->
      <span class="intro" v-bind:class="[formActive ? 'active' : '']">
        Send them a postcard,
        <br />they might even respond.
      </span>
      <span
        class="bye"
        v-bind:class="[!formActive ? 'active' : '']"
      >Your postcard to {{recipient}} is on the way...</span>
    </div>
    <div class="send__postcard postcard" v-bind:class="[formActive ? 'active' : '']">
      <div class="postcard__to">
        <div class="selector">
          <div
            :class="[{ selected: recipient == 'Hubert' }, 'to']"
            @click="toggleRecipient('Hubert')"
          >
            <div class="img dan" />
          </div>
          <div :class="[{ selected: recipient == 'Dan' }, 'to']" @click="toggleRecipient('Dan')">
            <div class="img dan" />
          </div>
          <div
            :class="[{ selected: recipient == 'Sophie' }, 'to']"
            @click="toggleRecipient('Sophie')"
          >
            <div class="img sophie" />
          </div>
          <div
            :class="[{ selected: recipient == 'Johan' }, 'to']"
            @click="toggleRecipient('Johan')"
          >
            <div class="img johan" />
          </div>
          <div :class="[{ selected: recipient == 'Lars' }, 'to']" @click="toggleRecipient('Lars')">
            <div class="img lars" />
          </div>
        </div>
      </div>
      <div class="postcard__body">
        <textarea :placeholder="'Share a thought with ' + recipient" autofocus v-model="message"></textarea>
      </div>
      <div class="postcard__from">
        <div class="inline-inputs">
          <input type="text" placeholder="Name" v-model="name" />,
          <input type="text" placeholder="Age" v-model="age" /> -
          <input type="text" placeholder="Country" v-model="country" />
        </div>
        <button class="send-button" @click="formSubmit()">
          <span>Send it →</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "send",
  props: ["to"],
  data() {
    return {
      formActive: true,
      // Form data
      name: "",
      age: "",
      country: "",
      message: "",
      recipient: this.to || "Hubert"
    };
  },
  // Get params from URL
  created() {},
  mounted() {},
  methods: {
    toggleRecipient(string) {
      this.recipient = string;
    },
    formSubmit() {
      var url =
        "https://script.google.com/macros/s/AKfycbxHDQ8lG0XKpllt8xDKwxDLANJ47KQPgrW3fA-jMA8lt7IS1-j4/exec";

      var data = {};

      data.to = this.recipient;
      data.name = this.name;
      data.age = this.age;
      data.country = this.country;

      data.message = this.message;

      console.log(data);

      data.formDataNameOrder = "['to','name','age','location','message']";
      data.formGoogleSheetName = "responses"; // default sheet name
      data.formGoogleSendEmail = ""; // no email by default

      var xhr = new XMLHttpRequest();
      xhr.open("POST", url);

      xhr.withCredentials = true;

      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

      var encoded = Object.keys(data)
        .map(function(k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
        })
        .join("&");

      xhr.send(encoded);

      this.formActive = false;
    }
  }
};
</script>


<style lang="scss" scoped>
.send {
  padding-top: 150px;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &__title {
    height: 15%;

    font-family: "Spectral", serif;
    text-align: center;
    font-weight: 300;
    font-size: 25px;
    font-style: italic;
    color: white;
    line-height: 1.2em;

    @media (min-width: 800px) {
      font-size: 30px;
    }

    @media (min-width: 1300px) {
      font-size: 35px;
    }

    & .intro {
      display: none;

      &.active {
        display: block;
      }
    }

    & .bye {
      display: none;

      &.active {
        display: block;
      }
    }
  }

  &__postcard {
    height: 75%;
    width: 90%;
    max-width: 800px;

    border: 1px solid white;
    padding: 20px;

    @media (min-width: 800px) {
      height: 70%;
      padding: 40px;
    }
  }
}

.postcard {
  opacity: 0;
  transition: all ease 1s;

  &.active {
    opacity: 1;
  }

  &__to {
    height: 10%;
  }

  &__body {
    height: 60%;

    @media (min-width: 800px) {
      height: 75%;
    }

    textarea {
      width: 100%;
      height: 100%;

      font-family: "Spectral", serif;
      font-weight: 300;
      font-size: 25px;
      font-style: italic;
      color: white;
      line-height: 1.2em;

      &::placeholder {
        color: white;
      }
    }
  }

  &__from {
    height: 30%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;

    @media (min-width: 800px) {
      height: 15%;
      flex-direction: row;
      align-items: flex-end;
    }
  }
}

.selector {
  display: flex;

  .to {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    margin-right: 20px;
    cursor: pointer;
    padding: 3px;
    opacity: 0.5;
    -webkit-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;

    &.selected {
      border: 1px solid white;
      opacity: 1;
    }

    .img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-size: cover;
      background-repeat: no-repeat;
      background-color: white;
    }
  }
}

.inline-inputs {
  color: white;
  input {
    width: 100px;
    height: 40px;
    padding: 0;
    color: white;
    font-style: normal;
    font-size: 14px;
    border: 0;
    border-bottom: 1px solid #dddddda3;

    @media (min-width: 800px) {
      width: initial;
    }

    &::placeholder {
      color: white;
    }

    &:focus {
      border-color: white;
    }
  }
}

.send-button {
  padding-bottom: 5px;
  border-bottom: 1px solid #ddd;

  &:hover {
    cursor: pointer;
    border-color: white;
  }

  span {
    width: fit-content;
    font-size: 14px;
    text-transform: uppercase;
    font-family: -apple-system, BlinkMacSystemFont, "Univers", Helvetica Neue,
      Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    color: white;
  }
}
</style>